import { TweenLite } from 'gsap';
import CustomEase from '../../lib/CustomEase';
import PixiPlugin from 'gsap/PixiPlugin';
import PixiSlide from './PixiSlide';

let PIXI;
if (typeof window !== 'undefined') {
  PIXI = require('pixi.js');
}
class PixiSlider {
  constructor(app) {
    // create track container
    this.app = app;
    this.currentSlide = 0;
    this.track = new PIXI.Container();
    this.hide();
    this.app.stage.addChild(this.track);
    // this.isContracted = false;
    // create slides and add to container

    window.addEventListener('resize', this.handleResize);
  }
  hide() {
    this.track.visible = false;
  }
  show() {
    this.track.visible = true;
  }
  populateSlideshow(slideImgs) {
    if (!this.populated) {
      this.populated = true;
      this.slideImgs = slideImgs;
      this.numSlides = slideImgs.length;
      this.createSlides();
    }
  }
  handleResize = () => {
    if (!this.populated) return;
    // TODO: could throttle this if you want...
    this.track.position.x = -this.currentSlide * window.innerWidth;
    this.slides.forEach(slide => {
      slide.updateSize();
    });
  };
  createSlides = () => {
    this.slides = this.slideImgs.map(
      (slideImg, index) => new PixiSlide(this.track, slideImg, this.app, index)
    );
  };
  loadImages(imgArray, callback) {
    // load any images that haven't been loaded yet
    const notLoadedYet = imgArray.filter(
      imgSrc => !PIXI.loader.resources[imgSrc]
    );
    if (notLoadedYet.length === 0) {
      callback();
    } else {
      PIXI.loader.add(notLoadedYet).load(callback);
    }
  }
  openCurrentChapter(onComplete) {
    this.slides[this.currentSlide].chapterOpen(onComplete);
  }
  contractSlides(reverse, duration) {
    // if (!this.isContracted) {
    //   this.isContracted = true;
    this.slides.forEach(slide => {
      slide.contract(reverse, duration);
    });
    // }
  }
  expandSlides(duration) {
    // this.isContracted = false;
    this.slides.forEach(slide => {
      slide.expand(duration);
    });
  }
  sliderMoveStart = () => {
    this.contractSlides();
  };
  sliderMoveComplete = callback => {
    // expand slides
    // fire some on complete so the React app knows to show text
    this.expandSlides();
    if (callback) {
      // TODO: should use this callback to reveal text in react instead of
      // the timeeout its currently doing
      callback();
    }
  };
  animateToIndex(
    index,
    completeCallback,
    duration = 2,
    ease = Power3.easeInOut,
    skipTextExit = false
  ) {
    return new Promise((resolve, reject) => {
      // collapse all slides
      this.currentSlide = index;
      this.sliderMoveStart();
      // transform track to correct slide
      setTimeout(() => {
        TweenLite.to(this.track, duration, {
          pixi: {
            x: index * -window.innerWidth,
          },
          ease: ease,
          onComplete: () => {
            resolve();
          },
        });
        setTimeout(() => {
          this.sliderMoveComplete(completeCallback);
        }, (duration - 0.5) * 1000);
      }, skipTextExit ? 0 : 200);
    });
  }

  skipToIndex(index) {
    this.currentSlide = index;

    // can just jump slider to index
    TweenLite.set(this.track, {
      pixi: {
        x: index * -window.innerWidth,
      },
    });
  }
  startChapterExit(currentChapterIndex) {
    // set slider to current chapter position
    this.skipToIndex(currentChapterIndex);
    // hide the slide in the current position
    this.slides[this.currentSlide].hide();
  }
  // Exit chapter to next slide transition
  chapterToNextChapter(
    type,
    imgSrc,
    drawCallback,
    currentChapterIndex,
    nextIndex,
    panCallback,
    completeCallback,
    startScreenAlpha = 0.4,
    endScreenAlpha = 0,
    focalX = 0.5,
    focalY = 0.5,
    currentSlideIndex
  ) {
    // Create a temporary slide that will perform the chapter to slider pan
    this.tempSlide = new PixiSlide(
      this.track,
      imgSrc,
      this.app,
      currentChapterIndex,
      () => {
        // On load of the temp slide, do the transition
        this.tempSlide.framedImage
          .screenToSlider(
            type,
            drawCallback,
            undefined,
            undefined,
            startScreenAlpha,
            endScreenAlpha,
            currentSlideIndex
          )
          .then(() => {
            // happens after screen to slider
            if (panCallback) {
              panCallback();
            }
          });

        setTimeout(() => {
          this.animateToIndex(
            nextIndex,
            undefined,
            undefined,
            undefined,
            true
          ).then(() => {
            //
            // On slide transition complete, show the hidden slide, and Destroy
            // the temporary slide
            this.slides[currentChapterIndex].show();
            this.tempSlide.destroy();
            this.tempSlide = undefined;

            if (completeCallback) {
              completeCallback();
            }
          });
        }, 1500);
      },
      focalX,
      focalY
    );
  }
}

export default PixiSlider;



// WEBPACK FOOTER //
// ./src/components/pixi/PixiSlider.js